module.exports = __webpack_public_path__ + "img/purple-import-icon.94cf376b.svg";